import { AnaColumn } from "../forms-template.service";


export const StampaRegistriCSGrid: AnaColumn[] = [

  {
    itemType: 'group',
    caption: '',
    class: '',
    colCount: '1',
    data: [
      {
        type: 'buttonArray',
        dataField: "",
        hideOnEdit: true,

        disabled: false,
        class: 'text-center p-2',
        horizontalAlignment: 'center',
        colAlignment: 'center',
        odataFilter: '',
        buttonArray: [
          {
            event: "invioRentri",
            name: "invioRentri",
            hint: "Invia Registro a Rentri",
            icon: 'iconRentri',
            class: '',
          },
        ]
      },

      // {
      //   type: 'campo',
      //   dataField: 'isMovimentato',//!------------ da fare 
      //   colVisible: true,
      //   dataType: 'string',
      //   caption: 'Inviati',
      //   width: 50,
      //   colAlignment: 'center',
      //   lista: {
      //     static: true,
      //     dataSource: '',
      //     valueExpr: 'key',
      //     displayExpr: 'label',
      //     items: [
      //       {
      //         key: true,
      //         label: '❌'
      //       },
      //       {
      //         key: false,
      //         label: '✅'
      //       },
      //       {
      //         key: null,
      //         label: '✅'
      //       }
      //     ]
      //   }
      // },
      {
        type: 'campo',
        dataField: 'id',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'Codice ID',
        colAlignment: 'left',

      },
      {
        type: 'campo',
        dataField: 'idSede',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'Codice Sede',
        colAlignment: 'left',

      },
      {
        type: 'campo',
        dataField: 'descrizione',
        colVisible: true,
        dataType: 'string',
        caption: 'Descrizione Registro',
        colAlignment: 'left',
      },
      {
        type: 'campo',
        dataField: 'sede_Descrizione',
        colVisible: true,
        dataType: 'string',
        caption: 'Descrizione Unità Locale',
        colAlignment: 'left',
      },
      {
        type: 'campoMultiData',
        dataField: 'dataProtocolloUltimoStampato',
        colVisible: true,
        dataType: 'object',
        caption: 'Ultima Reg. Definitiva',
        colAlignment: 'center',
        colWidth: 180
      },
      {
        type: 'campo',
        dataField: 'dataUltimoProtocolloStampato',
        colVisible: false,
        dataType: 'date',
        caption: 'Ultima Reg. Definitiva',
        colAlignment: 'left',
        colWidth: 180
      },
      {
        type: 'campo',
        dataField: 'numeroUltimoProtocollo',
        colVisible: false,
        dataType: 'string',
        caption: 'Ultimo protocollo',
        colAlignment: 'center',
        colWidth: 120
      },
      {
        type: 'campo',
        dataField: 'dataNumeroProtocolloUltimoRentri',
        colVisible: true,
        dataType: 'string',
        caption: 'Ultimo Inviato a Rentri',
        colAlignment: 'center',
        colWidth: 180
      },
      {
        type: 'campo',
        dataField: 'dataUltimoProtocolloRentri',
        colVisible: false,
        dataType: 'string',
        caption: 'Ultimo Inviato a Rentri',
        colAlignment: 'left',
        colWidth: 180
      },
      {
        type: 'campo',
        dataField: 'numeroUltimoProtocolloRentri',
        colVisible: false,
        dataType: 'string',
        caption: 'Ultimo protocollo a Rentri',
        colAlignment: 'left',
      },
      {
        type: 'campo',
        dataField: 'registroRentri',
        colVisible: true,
        dataType: 'string',
        caption: 'ID Rentri Registro',
        colAlignment: 'center',
        colWidth: 120
      },


    ]
  },

]
export const esportazioneRentriRegistriGrid: AnaColumn[] = [
  {
    itemType: 'group',
    caption: '',
    captionClass: 'd-none',
    colGroup: 10,
    colCount: '1',
    data: [
      {
        type: 'buttonArray',
        dataField: "",
        hideOnEdit: true,
        width: 30,
        disabled: false,
        class: 'text-center',
        horizontalAlignment: 'center',
        colAlignment: 'center',
        caption: 'Elabora',
        buttonArray:
          [{
            event: "elaboraRentri",
            name: "elaboraRentri",
            text: 'Elabora',
            hint: "Elabora Registro",
            icon: '',
            class: 'border bg-blue-zucchetti'
          },]

      },
      {
        type: 'campo',
        dataField: 'datainizio',
        colVisible: true,
        visible: true,
        dataType: 'date',
        caption: 'Data Inizio',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'protocolloinizio',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Prot. Inizio',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'datafine',
        colVisible: true,
        visible: true,
        dataType: 'date',
        caption: 'Data Fine',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'protocollofine',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Prot. Fine',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'stato',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Stato',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'pdf',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'PDF',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'nomefilexml',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'XML',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'firma',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Tipo Firma',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'dh',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Inviato a DH',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'altreinfo',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Note',
        colAlignment: 'center',
      },
    ]
  },


]

export const rentriRegistriElaboratigrid: AnaColumn[] = [
  {
    itemType: 'group',
    caption: '',
    captionClass: 'd-none',
    colGroup: 10,
    colCount: '1',
    data: [
      // {
      //   type: 'buttonArray',
      //   dataField: "",
      //   hideOnEdit: true,
      //   width: 30,
      //   disabled: false,
      //   class: 'text-center',
      //   horizontalAlignment: 'center',
      //   colAlignment: 'center',
      //   caption: 'Elabora',
      //   buttonArray:
      //     [{
      //       event: "elaboraRentri",
      //       name: "elaboraRentri",
      //       text: 'Elabora',
      //       hint: "Elabora Registro a Rentri",
      //       icon: '',
      //       class: 'border bg-blue-zucchetti'
      //     },]

      // },
      {
        type: 'campo',
        dataField: 'datainizio',
        colVisible: true,
        visible: true,
        dataType: 'date',
        caption: 'Data Inizio',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'protocolloinizio',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Prot. Inizio',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'datafine',
        colVisible: true,
        visible: true,
        dataType: 'date',
        caption: 'Data Fine',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'protocollofine',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Prot. Fine',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'stato',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Stato',
        colAlignment: 'center',
      },
      {
        type: 'buttonArray',
        dataField: "exportPdf",
        hideOnEdit: true,
        width: 30,
        disabled: false,
        class: 'text-center',
        horizontalAlignment: 'center',
        colAlignment: 'center',
        caption: 'PDF',
        buttonArray:
          [{
            event: "exportPdf",
            name: "exportPdf",
            text: 'PDF',
            hint: "Esporta PDF Registro",
            icon: '',
            class: 'border bg-blue-zucchetti'
          },]
      },
      {
        type: 'buttonArray',
        dataField: "exportXml",
        hideOnEdit: true,
        width: 30,
        disabled: false,
        class: 'text-center',
        horizontalAlignment: 'center',
        colAlignment: 'center',
        caption: 'XML',
        buttonArray:
          [{
            event: "exportXml",
            name: "exportXml",
            text: 'XML',
            hint: "Esporta XML Registro",
            icon: '',
            class: 'border bg-blue-zucchetti'
          },]
      },
      {
        type: 'campo',
        dataField: 'tipofirma',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Tipo Firma',
        colAlignment: 'center',
      },
      {
        type: 'buttonArray',
        dataField: "dh",
        hideOnEdit: true,
        width: 30,
        disabled: false,
        class: 'text-center',
        horizontalAlignment: 'center',
        colAlignment: 'center',
        caption: 'Inviato a DH',
        buttonArray:
          [{
            event: "conservazione",
            name: "conservazione",
            text: 'INVIA',
            hint: "Invia a DH",
            icon: '',
            class: 'border bg-blue-zucchetti'
          },]
      },
      {
        type: 'campo',
        dataField: 'altreinfo',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Note',
        colAlignment: 'center',
      },
    ]
  },


]
